import { IReviewData } from '~/src/features/reviews';

const otzovik = 'otzovik.com';
const yandex = 'maps.yandex.ru';

export const data: IReviewData[] = [
    {
        date: '23.01.2023 4:25',
        text: `Отличная приставка, которая может оживить даже старый телевизор, что и произошло в моем случае. Как я понял приставка имеет операционную систему андроид, ведь
            некоторые игры или приложения можно скачать на приставку, что очень радует меня. Поддерживает большое количество онлайн кинотеатров тоже расширяет границы просмотра,
            ведь смотришь не только ТВ программы. Маленькая, компактная и легенькая коробка, которая дает большой функционал. Как я считаю эта приставка не будет такая без
            интернета, ведь к большому сожалению хоть и похоже что это андроид, но без интернета не особо будет и развлекать, хоть и не пробовал. Также могу сказать за тех.
            поддержку, очень быстро и качественно оказывают помощь, очень здорово. Насчет пульта могу сказать, что со временем он облазиет и становится не приятным на ощупь,
            но в пакетике он хранится тоже отлично :)`,
        grade: 5,
        autor: 'Diana2467',
        source: otzovik,
    },
    {
        date: '24.12.2022 7:50',
        text: `Познакомились с данным провайдером в 2018 году после перехода с Аквилона и Ростелекома. Сказать, что мы были приятно удивлены - ничего не сказать. 1 - Скорость
            интернета. При тарифе в 100 мб/с через роутер ловит 92-94 мб/с, что является отличным показателем, к сравнению - Ростелеком и Аквилон выдавали 40-70 мб/с.
            2 - Практически полное отсутствие сбоев. За 3 года перебои происходили 3 раза и решались в чате с поддержкой за 5 минут 3 - Ремонтные работы с 2 ночи до 7 утра,
            что является огромным плюсом. 4 - Поддержка. Прекрасные люди сидят в технической поддержке. Помогают настроить роутер, исправить мелкие проблемы, а когда роутер
            уже подошел к своей смерти, оператор предложил не только роутеры от своей компании, но и аналоги на рынке, какие стабильнее, меньше ломаются и дольше живут.`,
        grade: 5,
        autor: 'Kseniia KN',
        source: otzovik,
    },
    {
        date: '04.09.2022 2:34',
        text: `Скорость соответствует заявленной, часто даже больше. 300 Мбит было без провалов и с запасом, сейчас подключил 750 Мбит, заявленная скорость есть.
            Вопрос по отключению телевидения и переходу на 750 Мбит решили оперативно по телефону.`,
        grade: 5,
        autor: 'guru31FEED',
        source: otzovik,
    },
    {
        date: '29.05.2022 9:52',
        text: `Проверенный и надежный поставщик услуг. Подключают быстро. После звонка оператору Дом. ру мастер приезжает не позднее следующего дня. Если нет собственного
            роутера, можно приобрести в рассрочку или взять в аренду. Соединение стабильное, сигнал без помех, непредвиденных поломок и отключений, вай фай ловит отлично.
            Проверку дом. ру прошел во время пандемии, когда дома были подключены к wi-fi и телефоны, и компьютер. Благодаря хорошему качеству`,
        grade: 5,
        autor: 'kuzevg99',
        source: otzovik,
    },
    {
        date: '17.05.2022 14:03',
        text: `Одни плюсы. Если и есть минусы то их очень немного, да и компания развивается и качество становится только лучше! Хотя я и обращаюсь с просьбами в ДОМ. РУ не
            очень часто Но каждый раз при обращении проблему решают очень быстро и профессионально. Ни разу не было такого, что бы нахамили или не смогли решить проблему.
            С интернетом и телевидением проблем нет всё устраивает. Сугубо моё мнение, ДОМ. РУ лучшая в этом сегменте рынка компания. И это них... я не заказной отзыв!!!
            Просто я пользуюсь услугами ДОМ. РУ уже много лет, и проблем практически нет. Хотя может быть это только мне так повезло. В любом случае я доволен как слон,
            что подключил ДОМ. РУ!!!`,
        grade: 5,
        autor: 'gayechka13',
        source: otzovik,
    },
    {
        date: '03.05.2022 20:22',
        text: `Отмечаю профессионализм и оперативность при восстановлении подключения к сети Интернета, показанные сервисным инженером Ярощук Д. А. Прибыл по вызову в
            адрес точно в ранее согласованное время, быстро и точно определил неисправность и способы её устранения и не ушел, пока не убедился в правильной работе оборудования
            и приложений пользователя. Спасибо.`,
        grade: 4,
        autor: 'Воговец',
        source: otzovik,
    },
    {
        date: '26.04.2022 18:04',
        text: `Я посоветовалась с ребятами более опытными на работе, дали мне небольшой список наших городских компаний, у которых более менее интернет нормальный.
            Везде оставили заявки, в дом. ру отреагировали быстрее всего, его и подключили) Консультант выслушала нас для чего нужен интернет и как часто мы им пользуемся,
            посоветовала пакет Мега Л. Дочь довольна, говорит, что интернет теперь работает намного лучше. Даже я заметила, что онлайн-фильмы и видео загружаются очень
            быстро. Надеемся, что все и дальше будет в таком же духе.`,
        grade: 4,
        autor: 'John Dou',
        source: otzovik,
    },
    {
        date: '20.04.2022 6:30',
        text: `Приветствую всех заглянувших на мой отзыв! Не так давно у нас поменяли домофон. Прежний в принципе всех устраивал, но прежний провайдер сдал свои полномочия,
            а на смену пришёл новый Дом. ру. С дом. ру мы знакомы много лет, пользуемся интернетом и телевидение тоже от этого провайдера. Теперь вот и домофон !       Домофон
            поставили не простой, а с видеонаблюдением. Конечно сразу возник вопрос, а придётся ли менять что-то в квартире, так как у нас уже был ремонт,
            то не хотелось новых дыр в стене`,
        grade: 5,
        autor: 'Mak10101',
        source: otzovik,
    },
    {
        date: '16.04.2022 21:15',
        text: `интернет просто летает, телевидение вообще супер жалеем, что не подключили раньше Не особо любим менять провайдеров, услугами последнего пользовались
            около пяти лет, с моменты заселения в квартиру. Но в последний год ужасно испортилось качество связи, частые поломки и полный игнор от техподдержки.
            Пришлось искать альтернативу. сосед рассказал, что он уже полгода как перешел на дом. ру и проблем нет. Почитали в интернете, вроде бы норм. Оставили заявку
            на сайте, в течение часа нам перезвонил менеджер, чтобы уточнить, когда нам удобно`,
        grade: 5,
        autor: 'robingoodka',
        source: otzovik,
    },
    {
        date: '16.04.2022 8:01',
        text: `работает стабильно, очень редко перебои один раз была поломка, но устранили оперативно Цифровое телевидение и интернет от дом. ру мы подключили
            месяцев восемь назад. Семья у нас большая, живем с мужем, двумя детьми и моими родителями в частном доме. И интернетом все пользуются, и телевизор любим
            посмотреть. Мы сразу выбрали самый полный пакет, потому что научены уже опытом, что на таком не экономят. Платим 1300 рублей. В первые два месяца была скидка,
            оплачивали половину от этой суммы. Каналов больше 150, на любой вкус) Качество картинки`,
        grade: 5,
        autor: 'Аноним4634839',
        source: otzovik,
    },
    {
        date: '21.02.2022 2:09',
        text: `перенастроить или вообще поменять.       Пообщался с знакомыми геймерами из Ростова, у кого какой интернет, многие хвалили дом. ру. Решил попробовать и я.
            Еще и удачно на акцию попал. За первый месяц заплатил всего 1 рубль. Это акция для всех новых абонентов. Роутер в аренду, правда, не предлагают, как многие
            другие провайдеры. Но у меня свой новый мощный. Расскажу по качестве инета. Подключил на 250, и правда просто летает! в первую неделю все тщательно проверял,
            скорость падала, но не намного. Такого, что почти в два раза меньше выдает, не было. Пользуюсь четвертый месяц, ни одной поломки.`,
        grade: 5,
        autor: 'Аноним4544800',
        source: otzovik,
    },
    {
        date: '26.01.2022 16:08',
        text: `Скорость сети. Качество услуги. Низкие цены. Отличные операторы поддержки. За 10 лет ни одного так и не нашел. Хотя искал весьма усердно. Но не к чему придраться.
            Здравствуйте. 10 лет назад, в далеком 2011 году, в наш славный город пришел ЭР-Телеком в лице провайдера Дом. РУ. Акции, быстрые подключения, ошеломляющая на то
            время скорость и прочее запестрело на всех рекламных стендах. Мне тут же захотелось попробовать, т. к. в городе на то время не было ни одного мало-мальски рабочего
            провайдера. Местные и весьма унылые мной не рассматривались`,
        grade: 5,
        autor: 'Дроздова Тася',
        source: otzovik,
    },
    {
        date: '26.01.2022 5:20',
        text: `У нас большой коттедж, и постоянно были проблемы с интернетом. Когда дети подросли, стало совсем невозможно им пользоваться из за большой нагрузки, решили
            сменить провайдера. Муж выбрал Дом ру, хотя я скептически относилась к этой затее… Была уверена, что в нашем районе да еще в частном доме интернет всегда будет
            через пень колоду!       Но вот пользуемся услугами нового провайдера второй месяц, и это превзошло все мои ожидания! Я даже на кухне могу спокойно`,
        grade: 5,
        autor: 'Mikamila90',
        source: otzovik,
    },
    {
        date: '25.01.2022 16:28',
        text: `Скорость, выбор тарифов и предложений. Проблема была решена в полном объёме Отсутствуют Хочу выразить благодарность мастеру Станиславу за оперативную помощь.
            По звонку, в этот же день приехал специалист и установил новый роутер. Также, устранил неполадки в работе кабельного ТВ. Сейчас всё работает безупречно. Спасибо.`,
        grade: 5,
        autor: 'Влад Коротков',
        source: otzovik,
    },
    {
        date: '21.01.2022 18:13',
        text: `Продвинутый провайдер, можно подключиться по акции, отличная скорость. для меня все же дороговато. Снимаю квартиру на двоих с однокурсником, нужен был
            недорогой и качественный интернет. Хозяева квартиры сказали самим искать провайдера, а заявку они потом подтвердят. В общем, решили подключаться через дом. ру,
            но долго спорили по тарифам))) Мне интернет нужен только для учебы и общения в соцсетях, а мой однокурсник – это просто заядлый геймер. В итоге сошлись на тарифе
            Облачный гейминг М (хотя я и сомневался) который подключили со скидкой в`,
        grade: 5,
        autor: 'ЛюсиЛью',
        source: otzovik,
    },
    {
        date: '20.01.2022 10:43',
        text: `После покупки квартиры встал вопрос о подключении интернета. И мне, и жене было важно, чтобы провайдер оказался без сюрпризов – из-за пандемии мы 3-4 дня в
            неделю работаем дома, а не в офисе. На съемной квартире с инетом были постоянные проблемы – скорость низкая, примерно раз в месяц в самый неподходящий момент
            вообще пропадал. В общем, намучились.       Интернет от Дом. ру есть у моих родителей, но они подключались, чтобы смотреть онлайн ТВ`,
        grade: 5,
        autor: 'yandenisov',
        source: otzovik,
    },
    {
        date: '17.01.2022 22:28',
        text: `Не могла понять почему не подключается интернет, в итоге решила позвонить, оказалось я забыла ввести пароль . Сотрудник довольно быстро мне помог и
            был вежливым, не могу не написать, что голос был очень приятным :) Меня попросили отставить отзыв, но я что-то не поняла куда, поэтому пишу сюда.....`,
        grade: 5,
        autor: 'Votlogin',
        source: otzovik,
    },
    {
        date: '17.01.2022 13:01',
        text: `интернетом от дом ру пользуюсь больше года. проверен и протестирован мной от и до. недавно сменила пакет услуг, чтобы еще и тв было. теперь уйма
            каналов в отличном качестве и еще доступ к онлайн-кинотеатрам, где показывают разные новинки.`,
        grade: 5,
        autor: 'Иванова Рената',
        source: otzovik,
    },
    {
        date: '13.01.2022 10:35',
        text: `Интернет в 100 Мб от моего бывшего провайдера и дом ру – кардинально разные вещи. Если ранее у нас были проблемы, когда все втроем включали свои гаджеры.
            То теперь можем одновременно и торрент качать, и фильмы онлайн смотреть, и в социальных сетях сидеть.`,
        grade: 5,
        autor: '5ArinA',
        source: otzovik,
    },
    {
        date: '13.01.2022 9:25',
        text: `У мамы пакет подключись 100. Очень довольна. Много каналов с ее любимыми фильмами. При подключении получили скидку на два месяца.
            Купили у них и приставку от дом ру. Вообще сомневалась насчет покупки, но оказалось что можно на 2 недели взять на тест, тогда решились.
            Оставили, все нравится.`,
        grade: 5,
        autor: 'Ермаков Григорий',
        source: otzovik,
    },
    {
        date: '12.01.2022 14:38',
        text: `Дом ру и у нас в квартире, и у родителей в частном доме. Всем все нравится. Поняли, что у нас отличный провайдер,
            когда с мужем ушли на удаленку, а дети на дистанционку. Скорость пришлось увеличить, а так все довольны.`,
        grade: 5,
        autor: 'Зыков Тихон',
        source: otzovik,
    },
    {
        date: '11.01.2022 16:42',
        text: `Я с дом ру с 2015 года. Были случаи, когда серьезные поломки были, хотел даже переподключиться. Но после того, как начали уделять внимание модернизации
            оборудования, все гладко и скорость хорошая. В дом ру вежливые менеджеры. Всегда все детально расскажут и подскажут,`,
        grade: 5,
        autor: 'Баженов Матвей',
        source: otzovik,
    },
    {
        date: '21.03.2022 4:53',
        text: `Лучший провайдер из тех что я пользовался!!!!! По сравнению с Ростелекомм и Ярнетом интернет бомбический за свои деньги!!!! Всегда работает, стабильный, да
            подключения ждали долго и отключать не хотели, но по работе интернета вопросов вообще нет`,
        grade: 5,
        autor: 'ai rin',
        source: yandex,
    },
    {
        date: '18.03.2022 8:54',
        text: `Скорость стабильная. Есть с чем сравнить. С прошлым провайдером намучались. Если подключали к вай фаю сразу три гаджета и два ноута, начинало все лагать.
            сейчас все ок, скорость одна из лучших.`,
        grade: 5,
        autor: 'Вальков Макс',
        source: yandex,
    },
    {
        date: '18.03.2022 8:53',
        text: `Только две недели назад сменила провайдера. Но я всем пока довольна. Консультанты вежливые. Мастера аккуратные, приходят в
            удобное для вас время. Не навязывают дополнительные услуги и покупку их оборудования.`,
        grade: 5,
        autor: 'Смагин А.Д',
        source: yandex,
    },
    {
        date: '19.03.2022 10:36',
        text: `Плачу за 100 мб. Столько и получаю. Нас двое, хватает с головой. С предыдущим провайдером были сплошные проблемы..
            Листал ленту в контакте, а фотки и у меня не грузились, ждал всегда 5-10 секунд, пока картинка появится. В дом ру инет летает.`,
        grade: 5,
        autor: 'Морев Илья',
        source: yandex,
    },
    {
        date: '18.03.2022 14:35',
        text: `Подключили родителям, они живут за городом. Часто привозим к ним детей, они с гаджетами, мобильный работает слабо. Приехали в офис,
            оформили заявку, сразу и нормальный роутер взяли в рассрочку. На следующий день все уже было готово.`,
        grade: 5,
        autor: 'Леня',
        source: yandex,
    },
    {
        date: '20.03.2022 5:52',
        text: `Подключился к дом ру недавно по акции. И интернет, и ТВ. Сначала думал, что не фонтан, скорость такая же, как и у бывшего провайдера.
            Пришел мастер, посмотрел, оказалось, что проблема в моем устаревшем роутере, который просто не тянет большую скорость. Заменил роутер, все летает`,
        grade: 5,
        autor: 'Акутин',
        source: yandex,
    },
    {
        date: '18.03.2022 2:57',
        text: `В нашем доме этот интернет у многих. Меня тоже заинтересовало, потому что своим интернетом была не очень довольна. В итоге и интернет подключила, и ТВ.
            Приставку купила у них, всю сумму вернули баллами, которые сейчас трачу на оплату онлайн-кинотеатров. Очень удобно.`,
        grade: 5,
        autor: 'Угрюмов Денис',
        source: yandex,
    },
    {
        date: '18.03.2022 7:13',
        text: `живем за городом, выбор провайдеров у нас ограничен. выбирали из того, что есть. но довольны. скорость лучше, чем у нас была в квартире.
            мастер очень доброжелательный к нам приезжал. сделал свою работу быстро и аккуратно.`,
        grade: 5,
        autor: 'молчанов',
        source: yandex,
    },
    {
        date: '20.03.2022 5:52',
        text: `Лучший провайдер в городе для частного дома! До этого пользовался услугами двух других компаний, ужасно недоволен. Платил за одну скорость, получал другую,
            в итоге два месяца переговоров с техподдержкой не дали мне результатов. Переподключился и очень рад.`,
        grade: 5,
        autor: 'семен побережный',
        source: yandex,
    },
    {
        date: '17.03.2022 6:56',
        text: `для меня надежный провайдер, пока им полностью доволен. я по выходным иногда подрабатываю, веду стримы. в общем интернет мне нужен хороший. раньше частенько
            бывшие операторы меня подводили. я не получал ту скорость, которая была мне нужна. дом ру дает стабильный трафик, все поломки чинятся быстро.`,
        grade: 5,
        autor: 'Барыгин Алексей',
        source: yandex,
    },
    {
        date: '19.03.2022 1:46',
        text: `Пользуюсь услугами этого провайдера более 15 лет. Нареканий нет. Все возникающие вопросы решались моментально, неисправности устранялись в течение суток,
            переход на другой тариф по времени в соответствие с нормативами. Работают профессионалы как в ремонтном отделе, так и операторы. Внимательны, культурны в общении.
            Менять провайдера даже и не думаю. Спасибо вам за обслуживание и за качество предоставляемых услуг.`,
        grade: 5,
        autor: 'прокопов',
        source: yandex,
    },
    {
        date: '19.03.2022 10:36',
        text: 'За 3 года ни одной проблемы не возникло. Разрывов нет (много играю в онлайн игры), скорость стабильная. Удивлен, что так много плохих отзывов.',
        grade: 5,
        autor: 'Измайлов Петр',
        source: yandex,
    },
    {
        date: '17.03.2022 0:32',
        text: 'Не поверите но всё устраивает, работает инет стабильно, что еще надо.',
        grade: 5,
        autor: 'Казимиров Артем',
        source: yandex,
    },
    {
        date: '20.03.2022 5:52',
        text: `Подключились недавно, приобрели оборудование, всё оплатили точно по договору. Интернетом я доволен, по ТВ приставке столько каналов,
            сколько и не успеваем смотреть) Но всё равно, учитывая что там идёт, хорошо что выбор большой. Детям всегда находятся мультики.
            Жена свои каналы смотрит по кулинарии и сериалы. Ютуб не тормозит, это уже для меня важно.`,
        grade: 5,
        autor: 'Юлий',
        source: yandex,
    },
    {
        date: '17.03.2022 2:03',
        text: `В целом нет претензий, потому что на моём тарифе ничего не виснет, для онлайн общения куда лучше, чем тот, который был раньше.
            Самое интересное, что работает отлично даже по вечерам, когда обычно перегруз, за всё время 1 раз всего подвис.Так что довольна.`,
        grade: 5,
        autor: 'Ноздрин Алексей',
        source: yandex,
    },
    {
        date: '18.03.2022 10:04',
        text: `На первые два месяца была обалденная скидка, сейчас подороже, чем когда пользовался предыдущей компанией, но зато без сбоев, все странички
            просто летают. поддержка оперативно, не приходится долго дозваниваться. никаких тормозов когда зависаешь в онлайне, это вообще супер.`,
        grade: 5,
        autor: 'Прыганов Илья',
        source: yandex,
    },
    {
        date: '17.03.2022 5:49',
        text: `Сервис у Дом.ру как раз такой, какой должен быть сервис. Подключались когда - к нам приехали уже на следующий день, все четко - отзвонились
            и мастер был как штык. Можем теперь спокойно пользоваться кучей каналов, смотришь кино - не тормозит. Просто интернет без задоринки работает,
            быстро и четко. Зависов еще не было ни разу.`,
        grade: 5,
        autor: 'Драчев',
        source: yandex,
    },
    {
        date: '17.03.2022 5:49',
        text: `Скорость приличная, мне кажется что дальше больше, чем обещали, но это чисто умозрительно. Главное что стоит своих денег, потому что ты
            получаешь именно то, что тебе пообещали. Были один раз неполадки, уже не помню из-за чего, но исправили быстро, буквально через пару часов.
            А больше ничего такого не помню.`,
        grade: 5,
        autor: 'Сынчук И.В',
        source: yandex,
    },
    {
        date: '17.03.2022 8:55',
        text: `Яндекс: Сервис у Дом.ру как раз такой, какой должен быть сервис. Подключались когда - к нам приехали уже на следующий день, все четко - отзвонились
            и мастер был как штык. Можем теперь спокойно пользоваться кучей каналов, смотришь кино - не тормозит. Просто интернет без задоринки работает,
            быстро и четко. Зависов еще не было ни разу.`,
        grade: 5,
        autor: 'Семен Игоревич',
        source: yandex,
    },
    {
        date: '18.03.2022 0:30',
        text: `За отличную работу провайдеру огромное спасибище! Последние полгода не вспоминаю о том кошмаре, который был раньше у другого поставщика.
            Может я живу близко к их точке на ул. Победы, но ко мне и мастер, когда была авария, примчался быстро, и работает все отлично.`,
        grade: 5,
        autor: 'Кошкин Илья',
        source: yandex,
    },
    {
        date: '20.03.2022 1:01',
        text: `Подключились к Дом.ру недавно, намучившись с предыдущим провайдером. Живем в центре, мастер приехал быстро, так чистенько все организовал, сделал,
            в тот же день уже пользовались новым интернетом. Скорость приличная, каналов много, есть что посмотреть и нам с мужем, и детям. И мне для работы удобно,
            быстро открываются все страницы.`,
        grade: 5,
        autor: 'суханов И.Д',
        source: yandex,
    },
    {
        date: '16.03.2022 23:32',
        text: `Удобно, что можно приостановить услуги. Уже пользовался, когда уезжал в командировку,действительно на время моего отсутствия услуга была приостановлена.
            Так что денег сэкономил. И техподдержкой доволен, обычно через них решаю такие вопросы, отвечают быстро, перенаправляют на нужного специалиста и решают твой вопрос.`,
        grade: 5,
        autor: 'Ярофеев',
        source: yandex,
    },
    {
        date: '16.03.2022 11:16',
        text: `Наверное это лучший интренет в нашем городе. на геймерском тарифе классно все летает. Без всяких там сбоев. Ничего не отключается.
            Если какие-то плановые работы или авария, объясняют конкретно что случилось и когда все исправят. Так держать!`,
        grade: 5,
        autor: 'Александр М.',
        source: yandex,
    },
    {
        date: '18.03.2022 8:40',
        text: `Услугами этого провайдера пользуюсь давно. Когда переезжали на новую квартиру из другого района сюда, на Магистральную в частный дом,
            думали будут сложности провести интернет и телевидение, но подключили нас оперативненько, даже вопросов не возникло. И работает все как положено.
            Скорость хорошая, кино, ролики ютьюба, в общем все.`,
        grade: 5,
        autor: 'Алексей',
        source: yandex,
    },
    {
        date: '07.03.2022 12:02',
        text: `Уже давно так-то с Дом.ру,и вот только положительные впечатления.Недавно захотелось увеличить скорость и кол во каналов,посмотрел другие тарифы.
            Без проблем только обратился - уже назавтра приехали и перенастроили все,роутер понадобилось обновить. Так что сервис на 5+.`,
        grade: 5,
        autor: 'Александр К.',
        source: yandex,
    },
    {
        date: '28.02.2022 15:47',
        text: `Игровой тариф у дом ру как раз то, что нужно. Разрывов не бывает, чтобы сидеть дни без интернета, как было раньше с другим поставщиком - такого
            вообще больше нет. Даже не вспоминаю. Это чувство комфорта, когда просто пользуешься и не боишься, что будет сбой. Со способами оплаты тоже всё хорошо.`,
        grade: 5,
        autor: 'Foma Kirillov',
        source: yandex,
    },
    {
        date: '24.02.2022 6:44',
        text: 'Быстро и качественно обслуживают',
        grade: 5,
        autor: 'Дмитрий Драп',
        source: yandex,
    },
    {
        date: '25.02.2022 14:51',
        text: 'Отличная компания, самый лучший интернет.',
        grade: 5,
        autor: 'Екатерира Качаева',
        source: yandex,
    },
    {
        date: '24.02.2022 23:30',
        text: `Возникла проблема со скоростью ,позвонил в службу поддержки , всё объяснил. Через минут двадцать приехал мастер и заменил роутер,т.к. старый уже
            не мог перебить сигналы других роутером...В доказательство, мастер ,всё наглядно показал при помощи ноутбука.В общем остался очень доволен сервисом Дом.ру.`,
        grade: 5,
        autor: 'tiger009',
        source: yandex,
    },
    {
        date: '22.02.2022 10:49',
        text: `Хороший провайдер.Пользуемся несколько лет.скорость устраивает,работает без сбоев а если возникают неполадки,то реагируют сразу.
            Особенно радует индивидуальный подход к клиентам.Нам продлили скидку на услугу 'Архив' на год по нашей просьбе,как постоянным клиентам.Спасибо администратору!`,
        grade: 5,
        autor: 'Ксения К.',
        source: yandex,
    },
    {
        date: '22.02.2022 22:53',
        text: `Добрый день! В нашем доме были перебои с электричеством, и придя с работы,поняла,что не работает ни телевизор,ни интернет.
            Думала перегорело оборудование. Созвонилась с оператором и ко мне оперативно выехал мастер. Всё проверил и устранил проблему.
            Ещё и подключил второй телевизор на кухне. Осталась довольна работой компании,которая заботится о своих клиентах.`,
        grade: 5,
        autor: 'Анастасия Л.',
        source: yandex,
    },
    {
        date: '19.02.2022 14:29',
        text: `Интернет вполне норм.у меня частный дом, подключилась к самому сильному тарифу засмотрись плюс 250. Раздача отличная на весь дом.
            Интернетом пользуется у нас пять человек, плюс тв. Никто никому не мешает, у всех все отлично ловит`,
        grade: 5,
        autor: 'Ксения К.',
        source: yandex,
    },
    {
        date: '19.02.2022 7:47',
        text: `нормальное качество интернета даже на самом дешевом тарифе со 100 мбит. хорошо держит одновременную работу телефона и ноута.
            фильмы не заикаются, по скорости скачивания норм. цены растут, но не смертельно и не каждый год.`,
        grade: 4,
        autor: 'Максим Махно',
        source: yandex,
    },
    {
        date: '20.02.2022 12:07',
        text: `провайдер не без мелких недочетов, но без жестких проблем. интернет работает, тв показывает, счета приходят с одной и той же
            цифрой из месяца в месяц, никакие услуги внезапно не подключаются.`,
        grade: 5,
        autor: 'Евгения Григорьева',
        source: yandex,
    },
    {
        date: '18.02.2022 6:55',
        text: `Подключила тариф 'облачный геймнг'. Единственный интернет, который позволяет играть в облаке в игре которые не тянет комп.
            На старом провайдере пробовала играть через GFN, но интернет явно не тянул.`,
        grade: 5,
        autor: 'Егия Ч.',
        source: yandex,
    },
    {
        date: '19.02.2022 5:34',
        text: `Норм провайдер, цена как у всех зато интернет не падает и по скорости не провисает. Роутер не стал у них брать,
            купил сам по скидке, все работает. А приставку вот взял для телевизора в кухне, который без смарт тв, в рассрочку.
            Хорошая, работает чисто от вай-фая. Аналоги не дешевле.`,
        grade: 5,
        autor: 'Игнатий Гогуль',
        source: yandex,
    },
    {
        date: '20.02.2022 17:47',
        text: `Интернет нужен для общения и работы. Раньше пользовалась другим провайдером, проблем было достаточно. Сейчас переключилась на Дом ру,
            тут и поддержка быстро реагирует, если неполадки какие, и нет такого, чтобы по несколько часов отсутствовал инет…
            За нескольколько месяцев был один перебой, и тот устранили с космической скоростью.`,
        grade: 5,
        autor: 'Сергей Кривов',
        source: yandex,
    },
    {
        date: '19.02.2022 8:39',
        text: `Уже много лет пользуюсь услугами этого оператора, замечательная компания, скорость всегда не ниже 100 Кб/с, показывает все каналы в цифре, если есть небольшие сбои,
            всегда можно дозвониться, всегда отвечают, оперативно принимают меры для устранения, молодцы! Очень доволен услугами Дом.ru, рекомендую всем!`,
        grade: 5,
        autor: 'Danil K.',
        source: yandex,
    },
    {
        date: '21.02.2022 4:54',
        text: 'Подключилась быстро, как подала заявку, на второй день уже пришли. Мастер возился недолго, мусора после себя не оставил. Скорость нормальная, для работы хватает.',
        grade: 5,
        autor: 'Иван Пронин',
        source: yandex,
    },
    {
        date: '20.02.2022 18:43',
        text: 'Пользуемся их услугами уже много лет. В целом все устраивает, все удобно. Все вопросы решают оперативно',
        grade: 5,
        autor: 'Никита Даниленко',
        source: yandex,
    },
    {
        date: '21.02.2022 3:34',
        text: `Оплачивает интернет фирма, так что пользуемся услугами дом ру, наверное лет 6-7, он у всех сотрудников. Оперативно реагирует поддержка, поэтому из-за связи не было
            проблем с нашей клиентурой. Все вовремя. Вне рабочее время качаю фильмы, пользуюсь свободно всеми нужными приложениями, соц сетями, за стабильность поручусь.`,
        grade: 5,
        autor: 'Иван С',
        source: yandex,
    },
    {
        date: '15.02.2022 23:18',
        text: `В родительской квартире интернет и тв уже около 3 лет. Самый недорогой тариф, на все хватает. Каналов много, их любимый Мосфильм есть и все основные.
            По интернету мама звонила всего 1 раз с «не работает». Посоветовали вытащить роутер из розетки, вытащить провод из роутера и подключить все обратно.
            Помогло. Проблем сложнее не было.`,
        grade: 4,
        autor: 'Виктория Д.',
        source: yandex,
    },
    {
        date: '14.02.2022 3:47',
        text: `Неплохой провайдер. Как по мне, то один из самых серьезных в городе, руководство ответственно относится к своей работе. Поломок практически нет.
            Я, правда, дома только по вечерам, но качество и скорость хорошее. А вот с прошлым провайдером скорость вечером так падала, что ничего делать было не возможно.`,
        grade: 5,
        autor: 'Ник',
        source: yandex,
    },
    {
        date: '13.02.2022 19:47',
        text: 'Обожаю дом ру всегда пойдут на встречу интерне работает здорово пользуюсь услугами данной организации лет 10',
        grade: 5,
        autor: 'Дмитрий М.',
        source: yandex,
    },
    {
        date: '10.02.2022 17:10',
        text: `Пользуюсь с 2012 года, подключение пропадало за эти годы всего 1 раз. Может мне просто повезло :) Стабильно и уверенно!
            Купили роутер у дом ру хотим увеличить скорость`,
        grade: 5,
        autor: 'Елена Г.',
        source: yandex,
    },
    {
        date: '10.02.2022 4:47',
        text: `Думала, в частном доме будет сложность провести интернет. Увидела объявление Дом.ру, позвонила, сказали без проблем, прислали мастера, все оборудование
            подключили. Быстренько и оперативненько. Киношку смотрю какую хочу, скорость стабильная, не виснет.`,
        grade: 5,
        autor: 'Олег А.',
        source: yandex,
    },
    {
        date: '12.02.2022 3:55',
        text: `Киноманю постоянно, поэтому и перешла на Дом.ру недавно, они обещали больше возможностей в этом плане. Не обманули, все работает как надо, связь лучше
            чем с предыдущим оператором. Свои деньги, считаю, отрабатывает.`,
        grade: 5,
        autor: 'Денис Тимонин',
        source: yandex,
    },
    {
        date: '03.02.2022 11:12',
        text: `Для тех кто ноет что интернет дом ру нехороший провайдер или недобросовестный перейдите на ростелеком и будет вам счастье.узнаете что такое шаманские
            танцы с бубном,по крайней мере касается твери.`,
        grade: 5,
        autor: 'Rainbow_lion',
        source: yandex,
    },
    {
        date: '01.02.2022 7:34',
        text: `Это не самый дорогой у нас интернет-провайдер, который за ту плату, которую берет, обеспечивает то, что и указано в договоре. По сравнению с предыдущим,
            с которым у меня были проблемы последние несколько лет, это вообще сказка. Можно выходить на стрим и не опасаться, что прервется связь.`,
        grade: 5,
        autor: 'Кристина Худорожкова',
        source: yandex,
    },
    {
        date: '07.02.2022 12:09',
        text: 'Отличный инет, нет вечером провалов в скорости как у другого популярного провайдера',
        grade: 5,
        autor: 'Наталья А.',
        source: yandex,
    },
    {
        date: '07.02.2022 13:35',
        text: `Проблем нет, как было с провайдером до этого. Пользуемся всей семьей, особенно дедушка с бабушкой телевидением))) Приставка у нас куплена тоже от них,
            мы сразу это сделали. Вовремя вносишь оплату и никаких проблем. Один раз просрочили,были в отпуске, но не пришлось ждать, пока все заработает. Мне по работе,
            детям поиграть. Дороговато, зато стабильно. А учитывая, что мы в частном доме, вообще круто.`,
        grade: 5,
        autor: 'Случайно переехала в Европу',
        source: yandex,
    },
    {
        date: '01.02.2022 3:00',
        text: `Был какой-то глюк поначалу с телевидением. Позвонили в техподдержку, на следующий день пришел мастер - все заработало. Больше (тьфу-тьфу-тьфу) вызывать
            не пришлось, все нужные каналы есть. Спасибо!`,
        grade: 5,
        autor: 'tiger009',
        source: yandex,
    },
    {
        date: '30.01.2022 21:22',
        text: `Очень нравится интернет вместе с телевидением от дом ру. Много разных каналов в отличном качестве. На ютубе можно посмотреть все от мультфильмов до музыки.
            Можно скачивать любые приложения и общаться и смотреть видео. Правда они немного подняли цену за пакет безлимитный интернет + тв.`,
        grade: 5,
        autor: 'Дима Г.',
        source: yandex,
    },
    {
        date: '29.01.2022 21:49',
        text: `Пользуемся данным провайдером уже много лет. Никаких проблем серьезных с ним не имели, все удобно и понятно в личном кабинете. Интернет работает без перебоев,
            телевидение( мы им пользуемся редко) также вполне устраивает.`,
        grade: 5,
        autor: 'Любовь Непогода',
        source: yandex,
    },
    {
        date: '29.01.2022 5:57',
        text: `Нареканий ни каких нет. На связи круглосуточно, чуть какая поломка или ещё что то, сразу принимают меры для устранения. Работают в выходные и праздничные дни.
            Очень часто предлагают какие то промо акции, скидки.`,
        grade: 5,
        autor: 'Danil K.',
        source: yandex,
    },
];
